var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',{staticClass:"form-control",attrs:{"id":_vm.name,"disabled":_vm.disabled}},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }